// This is a polyfill for the compiler. It is dumb
export const store = () => {
  let _storage = {
    _data       : {},
    setItem     : function(id, val) { return this._data[id] = val; },
    getItem     : function(id) { return '__IS_BUILD__' }
  }
  if (typeof localStorage !== 'undefined') _storage = localStorage
  return _storage
}

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

export const hashPass = function(x) {
  if (!x) return 0
  var hash = 0;
  if (x.length == 0) {
      return hash;
  }
  for (var i = 0; i < x.length; i++) {
      var char = x.charCodeAt(i);
      hash = ((hash<<5)-hash)+char;
      hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}



// WEBPACK FOOTER //
// ./client/components/utils.js